import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import AccountBalanceRoundedIcon from '@mui/icons-material/AccountBalanceRounded';
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import BookmarkBorderRoundedIcon from '@mui/icons-material/BookmarkBorderRounded';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import ChatBubbleRoundedIcon from '@mui/icons-material/ChatBubbleRounded';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import CloudDownloadRoundedIcon from '@mui/icons-material/CloudDownloadRounded';
import DeleteForeverRoundedIcon from '@mui/icons-material/DeleteForeverRounded';
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import EventRoundedIcon from '@mui/icons-material/EventRounded';
import FlagRoundedIcon from '@mui/icons-material/FlagRounded';
import FormatListBulletedRoundedIcon from '@mui/icons-material/FormatListBulletedRounded';
import FormatListNumberedRoundedIcon from '@mui/icons-material/FormatListNumberedRounded';
import ForwardRoundedIcon from '@mui/icons-material/ForwardRounded';
import HeadsetMicRoundedIcon from '@mui/icons-material/HeadsetMicRounded';
import HelpRoundedIcon from '@mui/icons-material/HelpRounded';
import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import KeyboardArrowLeftRoundedIcon from '@mui/icons-material/KeyboardArrowLeftRounded';
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';
import KeyboardArrowUpRoundedIcon from '@mui/icons-material/KeyboardArrowUpRounded';
import LaunchRoundedIcon from '@mui/icons-material/LaunchRounded';
import LibraryBooksRoundedIcon from '@mui/icons-material/LibraryBooksRounded';
import LockOpenRoundedIcon from '@mui/icons-material/LockOpenRounded';
import LockRoundedIcon from '@mui/icons-material/LockRounded';
import MailOutlineRoundedIcon from '@mui/icons-material/MailOutlineRounded';
import MenuBookRoundedIcon from '@mui/icons-material/MenuBookRounded';
import ModeEditRoundedIcon from '@mui/icons-material/ModeEditRounded';
import MonetizationOnRoundedIcon from '@mui/icons-material/MonetizationOnRounded';
import MoodRoundedIcon from '@mui/icons-material/MoodRounded';
import NoteAddOutlinedIcon from '@mui/icons-material/NoteAddOutlined';
import PermContactCalendarRoundedIcon from '@mui/icons-material/PermContactCalendarRounded';
import PhoneRoundedIcon from '@mui/icons-material/PhoneRounded';
import PlayCircleRoundedIcon from '@mui/icons-material/PlayCircleRounded';
import PresentToAllRoundedIcon from '@mui/icons-material/PresentToAllRounded';
import RemoveCircleOutlineRoundedIcon from '@mui/icons-material/RemoveCircleOutlineRounded';
import ReplayRoundedIcon from '@mui/icons-material/ReplayRounded';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import SecurityRoundedIcon from '@mui/icons-material/SecurityRounded';
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import SignalWifiConnectedNoInternet4RoundedIcon from '@mui/icons-material/SignalWifiConnectedNoInternet4Rounded';
import StarBorderRoundedIcon from '@mui/icons-material/StarBorderRounded';
import StarRateRoundedIcon from '@mui/icons-material/StarRateRounded';
import SupervisorAccountRoundedIcon from '@mui/icons-material/SupervisorAccountRounded';
import ThumbDownRoundedIcon from '@mui/icons-material/ThumbDownRounded';
import ThumbUpAltRoundedIcon from '@mui/icons-material/ThumbUpAltRounded';
import VisibilityOffRoundedIcon from '@mui/icons-material/VisibilityOffRounded';
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';

import AccountFilled from './assets/account-filled.svg?react';
import Account from './assets/account.svg?react';
import ArrowLeft from './assets/arrow-left.svg?react';
import ArrowRight from './assets/arrow-right.svg?react';
import Bank from './assets/bank.svg?react';
import AmericanExpress from './assets/cc-amex.svg?react';
import DinersClub from './assets/cc-diners-club.svg?react';
import Discover from './assets/cc-discover.svg?react';
import Jcb from './assets/cc-jcb.svg?react';
import Mastercard from './assets/cc-mastercard.svg?react';
import Visa from './assets/cc-visa.svg?react';
import CircleClose from './assets/circle-close.svg?react';
import CourseFilled from './assets/courses-filled.svg?react';
import Course from './assets/courses.svg?react';
import Discount from './assets/discount.svg?react';
import Download from './assets/download.svg?react';
import Jobs from './assets/jobs.svg?react';
import LinearCheckMark from './assets/linear-checkmark.svg?react';
import MoodleFilled from './assets/moodle-filled.svg?react';
import Moodle from './assets/moodle.svg?react';
import OdtQuestionFilled from './assets/odt-question-filled.svg?react';
import OdtQuestion from './assets/odt-question.svg?react';
import PassFilled from './assets/pass-filled.svg?react';
import Pass from './assets/pass.svg?react';
import PlanFilled from './assets/plan-filled.svg?react';
import Plan from './assets/plan.svg?react';
import PrepFilled from './assets/prep-filled.svg?react';
import Prep from './assets/prep.svg?react';
import RatingFilled from './assets/rating-filled.svg?react';
import Rating from './assets/rating.svg?react';
import RewardsFilled from './assets/rewards-filled.svg?react';
import Rewards from './assets/rewards.svg?react';
import Support from './assets/support.svg?react';
import TrackTime from './assets/track-time.svg?react';

export function AmericanExpressIcon(props: SvgIconProps) {
  return <SvgIcon component={AmericanExpress} {...props} />;
}

export function DinersClubIcon(props: SvgIconProps) {
  return <SvgIcon component={DinersClub} {...props} />;
}

export function DiscoverIcon(props: SvgIconProps) {
  return <SvgIcon component={Discover} {...props} />;
}

export function JcbIcon(props: SvgIconProps) {
  return <SvgIcon component={Jcb} {...props} />;
}

export function MastercardIcon(props: SvgIconProps) {
  return <SvgIcon component={Mastercard} {...props} />;
}

export function VisaIcon(props: SvgIconProps) {
  return <SvgIcon component={Visa} {...props} />;
}

export function BankIcon(props: SvgIconProps) {
  return <SvgIcon component={Bank} {...props} />;
}

export function BankOutlinedIcon(props: SvgIconProps) {
  return <AccountBalanceRoundedIcon {...props} />;
}

export function ThumbsUpIcon(props: SvgIconProps) {
  return <ThumbUpAltRoundedIcon {...props} />;
}

export function ThumbsDownIcon(props: SvgIconProps) {
  return <ThumbDownRoundedIcon {...props} />;
}

export function MailIcon(props: SvgIconProps) {
  return <MailOutlineRoundedIcon {...props} />;
}

export function AddNoteIcon(props: SvgIconProps) {
  return <NoteAddOutlinedIcon {...props} />;
}

export function CoursesIcon(props: SvgIconProps) {
  return <BookmarkBorderRoundedIcon {...props} />;
}

export function OdtQuestionIcon(props: SvgIconProps) {
  return <SvgIcon component={OdtQuestion} viewBox="0 0 36 37" {...props} />;
}

export function OdtQuestionFilledIcon(props: SvgIconProps) {
  return <SvgIcon component={OdtQuestionFilled} viewBox="0 0 40 40" {...props} />;
}

export function DiscountIcon(props: SvgIconProps) {
  return <SvgIcon component={Discount} viewBox="0 0 18 22" {...props} />;
}

export function SecurityIcon(props: SvgIconProps) {
  return <SecurityRoundedIcon {...props} />;
}

export function AccountIcon(props: SvgIconProps) {
  return <SvgIcon component={Account} viewBox="0 0 32 32" {...props} />;
}

export function RatingStarIcon(props: SvgIconProps) {
  return <StarRateRoundedIcon {...props} />;
}

export function AddCircleIcon(props: SvgIconProps) {
  return <AddCircleOutlineRoundedIcon {...props} />;
}

export function RemoveCircleIcon(props: SvgIconProps) {
  return <RemoveCircleOutlineRoundedIcon {...props} />;
}

export function NoInternetIcon(props: SvgIconProps) {
  return <SignalWifiConnectedNoInternet4RoundedIcon {...props} />;
}

export function OneOnOneSessionIcon(props: SvgIconProps) {
  return <SupervisorAccountRoundedIcon {...props} />;
}

export function StartLessonIcon(props: SvgIconProps) {
  return <PresentToAllRoundedIcon {...props} />;
}

export function SendIcon(props: SvgIconProps) {
  return <SendRoundedIcon {...props} />;
}

export function RosterIcon(props: SvgIconProps) {
  return <FormatListBulletedRoundedIcon {...props} />;
}
export function EmailIcon(props: SvgIconProps) {
  return <EmailRoundedIcon {...props} />;
}
export function CheckCircleIcon(props: SvgIconProps) {
  return <CheckCircleOutlineRoundedIcon {...props} />;
}
export function DeleteIcon(props: SvgIconProps) {
  return <DeleteForeverRoundedIcon {...props} />;
}
export function EditIcon(props: SvgIconProps) {
  return <ModeEditRoundedIcon {...props} />;
}
export function ContactCalendarIcon(props: SvgIconProps) {
  return <PermContactCalendarRoundedIcon {...props} />;
}
export function CircularPlayIcon(props: SvgIconProps) {
  return <PlayCircleRoundedIcon {...props} />;
}
export function HistoryIcon(props: SvgIconProps) {
  return <HistoryRoundedIcon {...props} />;
}
export function FutureCourseIcon(props: SvgIconProps) {
  return <ForwardRoundedIcon {...props} />;
}
export function JobsIcon(props: SvgIconProps) {
  return <Jobs {...props} />;
}
export function DownloadIcon(props: SvgIconProps) {
  return <DownloadRoundedIcon {...props} />;
}
export function ArrowForwardIcon(props: SvgIconProps) {
  return <ArrowForwardRoundedIcon {...props} />;
}
export function ArrowBackIcon(props: SvgIconProps) {
  return <ArrowBackRoundedIcon {...props} />;
}
export function LockedIcon(props: SvgIconProps) {
  return <LockRoundedIcon {...props} />;
}
export function UnLockedIcon(props: SvgIconProps) {
  return <LockOpenRoundedIcon {...props} />;
}
export function CloseIcon(props: SvgIconProps) {
  return <CloseRoundedIcon {...props} />;
}
export function AddIcon(props: SvgIconProps) {
  return <AddRoundedIcon {...props} />;
}
export function CloudDownloadIcon(props: SvgIconProps) {
  return <CloudDownloadRoundedIcon {...props} />;
}
export function ReplayIcon(props: SvgIconProps) {
  return <ReplayRoundedIcon {...props} />;
}
export function HeadsetMicIcon(props: SvgIconProps) {
  return <HeadsetMicRoundedIcon {...props} />;
}
export function SearchLenseIcon(props: SvgIconProps) {
  return <SearchRoundedIcon {...props} />;
}
export function CircleCheckRoundedIcon(props: SvgIconProps) {
  return <CheckCircleRoundedIcon {...props} />;
}
export function InfoIcon(props: SvgIconProps) {
  return <InfoRoundedIcon {...props} />;
}
export function ArrowUpIcon(props: SvgIconProps) {
  return <KeyboardArrowUpRoundedIcon {...props} />;
}
export function ArrowDownIcon(props: SvgIconProps) {
  return <KeyboardArrowDownRoundedIcon {...props} />;
}
export function ArrowRightIcon(props: SvgIconProps) {
  return <KeyboardArrowRightRoundedIcon {...props} />;
}
export function ArrowLeftIcon(props: SvgIconProps) {
  return <KeyboardArrowLeftRoundedIcon {...props} />;
}
export function SmileyIcon(props: SvgIconProps) {
  return <MoodRoundedIcon {...props} />;
}
export function WarningIcon(props: SvgIconProps) {
  return <WarningRoundedIcon {...props} />;
}

export function PhoneIcon(props: SvgIconProps) {
  return <PhoneRoundedIcon {...props} />;
}

export function CircleCloseIcon(props: SvgIconProps) {
  return <SvgIcon component={CircleClose} viewBox="0 0 1024 1024" {...props} />;
}

export function ArrowLeftWBIcon(props: SvgIconProps) {
  return <SvgIcon component={ArrowLeft} viewBox="0 0 1024 1024" {...props} />;
}

export function InvoiceDownloadIcon(props: SvgIconProps) {
  return <SvgIcon component={Download} viewBox="0 0 1052 1024" {...props} />;
}

export function ArrowRightWBIcon(props: SvgIconProps) {
  return <SvgIcon component={ArrowRight} viewBox="0 0 1052 1024" {...props} />;
}

export function StarBorderIcon(props: SvgIconProps) {
  return <StarBorderRoundedIcon {...props} />;
}

export function CheckIcon(props: SvgIconProps) {
  return <CheckRoundedIcon {...props} />;
}

export function CancelCircularIcon(props: SvgIconProps) {
  return <CancelRoundedIcon {...props} />;
}

export function FlagIcon(props: SvgIconProps) {
  return <FlagRoundedIcon {...props} />;
}

export function VisibilityOnIcon(props: SvgIconProps) {
  return <VisibilityRoundedIcon {...props} />;
}

export function VisibilityOffIcon(props: SvgIconProps) {
  return <VisibilityOffRoundedIcon {...props} />;
}

export function MessageIcon(props: SvgIconProps) {
  return <ChatBubbleRoundedIcon {...props} />;
}

export function LogoutIcon(props: SvgIconProps) {
  return <LaunchRoundedIcon {...props} />;
}

export function WhyBridgeIcon(props: SvgIconProps) {
  return <HelpRoundedIcon {...props} />;
}

export function CalenderIcon(props: SvgIconProps) {
  return <EventRoundedIcon {...props} />;
}

export function NumberListingIcon(props: SvgIconProps) {
  return <FormatListNumberedRoundedIcon {...props} />;
}

export function KnowledgeBaseIcon(props: SvgIconProps) {
  return <LibraryBooksRoundedIcon {...props} />;
}

export function BillingIcon(props: SvgIconProps) {
  return <MonetizationOnRoundedIcon {...props} />;
}

export function SupportIcon(props: SvgIconProps) {
  return <SvgIcon component={Support} viewBox="0 0 32 32" {...props} />;
}

export function AccountFilledIcon(props: SvgIconProps) {
  return <SvgIcon component={AccountFilled} viewBox="0 0 32 32" {...props} />;
}

export function ManualIcon(props: SvgIconProps) {
  return <MenuBookRoundedIcon {...props} />;
}

export function MyTimeIcon(props: SvgIconProps) {
  return <AccessTimeRoundedIcon {...props} />;
}

export function CourseIcon(props: SvgIconProps) {
  return <SvgIcon component={Course} viewBox="0 0 32 32" {...props} />;
}

export function CourseFilledIcon(props: SvgIconProps) {
  return <SvgIcon component={CourseFilled} viewBox="0 0 32 32" {...props} />;
}

export function PassIcon(props: SvgIconProps) {
  return <SvgIcon component={Pass} viewBox="0 0 32 32" {...props} />;
}

export function PassFilledIcon(props: SvgIconProps) {
  return <SvgIcon component={PassFilled} viewBox="0 0 32 32" {...props} />;
}

export function PrepIcon(props: SvgIconProps) {
  return <SvgIcon component={Prep} viewBox="0 0 32 32" {...props} />;
}

export function PrepFilledIcon(props: SvgIconProps) {
  return <SvgIcon component={PrepFilled} viewBox="0 0 32 32" {...props} />;
}

export function PlanIcon(props: SvgIconProps) {
  return <SvgIcon component={Plan} viewBox="0 0 32 32" {...props} />;
}
export function PlanFilledIcon(props: SvgIconProps) {
  return <SvgIcon component={PlanFilled} viewBox="0 0 32 32" {...props} />;
}
export function RatingIcon(props: SvgIconProps) {
  return <SvgIcon component={Rating} viewBox="0 0 32 32" {...props} />;
}
export function RatingFilledIcon(props: SvgIconProps) {
  return <SvgIcon component={RatingFilled} viewBox="0 0 32 32" {...props} />;
}
export function TrackTimeIcon(props: SvgIconProps) {
  return <SvgIcon component={TrackTime} viewBox="0 0 32 32" {...props} />;
}
export function MoodleIcon(props: SvgIconProps) {
  return <SvgIcon component={Moodle} viewBox="0 0 32 32" {...props} />;
}
export function MoodleFilledIcon(props: SvgIconProps) {
  return <SvgIcon component={MoodleFilled} viewBox="0 0 32 32" {...props} />;
}
export function LinearCheckMarkIcon(props: SvgIconProps) {
  return <SvgIcon component={LinearCheckMark} viewBox="0 0 32 32" {...props} />;
}
export function RewardsIcon(props: SvgIconProps) {
  return <SvgIcon component={Rewards} viewBox="0 0 36 36" {...props} />;
}
export function RewardsFilledIcon(props: SvgIconProps) {
  return <SvgIcon component={RewardsFilled} viewBox="0 0 36 36" {...props} />;
}
